import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/* ปุ่ม "กลับ" ของหน้าแสดงข้อมูล

   เดิมวิ่งกลับหน้ารายการของเอกสารนั้นแบบตายตัว ทำให้คนที่กดรหัสเอกสาร
   มาจากหน้าอื่น (เช่น รายงาน PO ค้างรับ) ถูกพากลับไปผิดหน้า

   ถ้ามีประวัติการเข้าชมอยู่ในแอป (react-router เก็บ index ไว้ที่ history.state.idx)
   ให้ถอยกลับหน้าที่ส่งมาจริง ๆ ถ้าไม่มี (เปิด url ตรง / เพิ่งรีเฟรช)
   ค่อยกลับไปหน้ารายการตาม fallback */
export default function useGoBack(fallback) {
  const navigate = useNavigate();

  return useCallback(() => {
    const idx = window.history?.state?.idx;
    if (typeof idx === "number" && idx > 0) {
      navigate(-1);
      return;
    }
    if (fallback) navigate(fallback, { replace: true });
  }, [navigate, fallback]);
}
